// Wrap the fixed position element with a spacer so the page content offset does not need to be adjusted
// when the element position is fixed
jQuery(function () {
  jQuery("[data-behaviour~=toggleable-fixed-position]").each(function () {
    var oldPositioning, newPositioning;
    var element = jQuery(this);
    var spacer = element
      .wrap('<div class="fixed-position-spacer" role="region" aria-label="Sitewide Banner Content"></div>')
      .parent();

    // BEHAVIOUR

    jQuery(window).on("resize", updateSpacerDimensions);
    // Ensures that the width is calculated using a fully rendered page
    jQuery(window).on("load", updateSpacerDimensions);

    // The content can change height without the window resizing — a dismissable banner hides itself,
    // a collapsable one expands — and the spacer would otherwise hold the stale height.
    if (window.ResizeObserver) {
      new ResizeObserver(updateSpacerDimensions).observe(this);
    }

    // HELPER FUNCTIONS

    function updateSpacerDimensions() {
      newPositioning = element.css("position");

      if (newPositioning == "fixed") {
        spacer.height(element.outerHeight());
      } else if (newPositioning != "fixed" && oldPositioning != newPositioning) {
        spacer.height("");
      }

      oldPositioning = newPositioning;
    }

    // INITIALIZE

    // ADD the class for fixed position
    element.addClass("fixed-position-spacer__content");

    updateSpacerDimensions(element, spacer);
  });
});
